import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "./element-variables.scss";
import "./styles.scss";
import "./axios";
import VueClipboard from "vue-clipboard2";

Vue.use(ElementUI);
Vue.use(VueClipboard);

Vue.prototype.$eventbus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
